import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { alertSelect, alertUpdate } from '../_stores/slice/alert';
import { useTheme } from '@mui/styles';
import { Alert, Snackbar } from '@mui/material';


/** 
 * 提示框（浮動）
 * type = error    紅
 * type = warning  橘
 * type = info     藍
 * type = success  綠
 */
export function AlertSnackbar(){

  const theme = useTheme();
  const dispatch = useDispatch();
  const alertStore = useSelector(alertSelect);
  const alert = alertStore.Snackbar;
  const autoHide = 3000;  // 停留秒數

  let backgroundColor = theme.palette.alert.success;
  switch (alert.type) {
    case 'error':
      backgroundColor = theme.palette.alert.error;
      break;
    case 'warning':
      backgroundColor = theme.palette.alert.warning;
      break;
    case 'info':
      backgroundColor = theme.palette.alert.info;
      break;
    case 'success':
      backgroundColor = theme.palette.alert.success;
      break;
    default:
      break;
  }


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    let newAlertStore = {...alertStore};
    newAlertStore.Snackbar.open = false;
    newAlertStore.Snackbar.msg = null;
    dispatch(alertUpdate({
      ...newAlertStore
    }));
  };


  return (
    <Snackbar
      open={alert.open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      autoHideDuration={alert.type === 'error' ? null : autoHide}
      sx={{
        width: '100vw',
        top: '100px !important',
        [theme.breakpoints.down('md')]: {
          padding: 0,
        },
        [theme.breakpoints.down('sm')]: {
          padding: '0 5vw',
          left: 0,
          right: 0,
        },
      }}
    >

      <Alert
        onClose={handleClose}
        severity={alert.type}
        variant='filled'
        sx={{
          width: '60%',
          fontWeight: 700,
          boxShadow: theme.palette.shadow.main,
          backgroundColor: backgroundColor,
          [theme.breakpoints.down('lg')]: {
            width: '80%'
          },
          [theme.breakpoints.down('sm')]: {
            width: '100%'
          },
        }}
      >
        {alert.msg}
      </Alert>

    </Snackbar>
  )
}